


























































import { Component, Prop, Vue } from "vue-property-decorator";
import { IProductCard } from "@/@types/menu/menu/menu";

import BarOrderItem from "../bar-order-item.vue";

@Component({ components: { BarOrderItem } })
export default class BarOrderConstructorDishs extends Vue {
  @Prop({ type: Array, default: () => [] }) dishs!: Array<IProductCard>;
  @Prop({ type: Number, default: 0 }) isActive!: number;
  @Prop({ type: Number, default: 0 }) length!: number;
}
